import api from "../_api";

const viewCommunication = async (context, body) => {
  await api.viewCommunication(body);
};

const getCommunications = async ({ commit }, body) => {
  const result = await api.getCommunications(body);
  commit("STORE_COMMUNICATION", result.data);
};

const getCommunicationsNotification = async ({ commit }, body) => {
  const result = await api.getCommunications(body);
  commit("STORE_COMMUNICATION_NOTIFICATION", result.data);
};

export default {
  viewCommunication,
  getCommunications,
  getCommunicationsNotification
};
